import { HttpContextToken } from '@angular/common/http';

export const SKIP_NOT_FOUND_HANDLING = new HttpContextToken<boolean>(
    () => false
);
